import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import TransactionHistory from "../../components/TransactionHistory/TransactionHistory";
import LoginHeaderA from "../../components/header/LoginHeaderA";
import Footer from "../../components/footer/FooterW";
import bankicon from "../../images/shapes/bank-pound-icon2 4.png";
import wallet from "../../images/shapes/Group 37274 (1).png";
import { useLocation } from "react-router-dom";
import { API_URL } from "../../constant";
import tcunitswallet from "../../images/shapes/tc-units-wallet 2.png";
import tccashwallet from "../../images/shapes/tc-cash-wallet 1.png";
import walletcashicon from "../../images/shapes/wallet-cash-icon3 2.png";

const WalletA = () => {
  const [transactions, setTransactions] = useState([]);
  const [balance, setBalance] = useState(0);
  const [loading, setLoading] = useState(true);
  const [apiStatus, setApiStatus] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [showPopup, setShowPopup] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [timeLeft, setTimeLeft] = useState(300); // 5 minutes in seconds

  // Session timeout duration - 5 minutes
  const SESSION_TIMEOUT = 5 * 60 * 1000; // 5 minutes in milliseconds
  const WARNING_TIME = 60 * 1000; // Show warning 1 minute before timeout

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const tempTokenKey = urlParams.get("temp_token_key");

    if (tempTokenKey) {
      const tempToken = localStorage.getItem(tempTokenKey);
      if (tempToken) {
        localStorage.setItem("auth_token", tempToken);
        localStorage.removeItem(tempTokenKey);
        // Clean up URL
        window.history.replaceState(
          {},
          document.title,
          window.location.pathname
        );
      }
    }
  }, []);

  const handleClick = () => {
    if (balance < 20000) {
      setShowMessage(true);
      setTimeout(() => {
        setShowMessage(false);
      }, 5000);
    } else {
      alert("Conversion process started!");
    }
  };

  const logout = () => {
    console.log("🔄 Auto-logout due to inactivity");
    localStorage.removeItem("auth_token");
    localStorage.removeItem("is_first_login");
    localStorage.removeItem("last_activity_time");
    localStorage.removeItem("user");
    navigate("/work_with_tcuk");
  };

  const resetTimer = () => {
    const newTime = Date.now().toString();
    localStorage.setItem("last_activity_time", newTime);
    setTimeLeft(300); // Reset to 5 minutes
    console.log("🔄 Activity detected, session timer reset");
  };

  const setupActivityListeners = () => {
    const events = [
      "mousedown",
      "mousemove",
      "keypress",
      "keydown",
      "scroll",
      "touchstart",
      "click",
      "touchmove",
      "wheel",
    ];

    events.forEach((event) => {
      document.addEventListener(event, resetTimer, { passive: true });
    });

    // Also reset on visibility change (when user comes back to tab)
    document.addEventListener("visibilitychange", () => {
      if (!document.hidden) {
        resetTimer();
      }
    });

    return () => {
      events.forEach((event) => {
        document.removeEventListener(event, resetTimer);
      });
      document.removeEventListener("visibilitychange", resetTimer);
    };
  };

  const checkSession = () => {
    const token = localStorage.getItem("auth_token");
    const lastActivity = localStorage.getItem("last_activity_time");

    if (!token) {
      console.log("❌ No token found");
      navigate("/work_with_tcuk");
      return false;
    }

    if (lastActivity) {
      const currentTime = Date.now();
      const elapsedTime = currentTime - parseInt(lastActivity);
      const remainingTime = Math.max(0, SESSION_TIMEOUT - elapsedTime);

      setTimeLeft(Math.floor(remainingTime / 1000));

      console.log(
        `⏰ Session check: ${Math.floor(remainingTime / 1000)}s remaining`
      );

      if (elapsedTime > SESSION_TIMEOUT) {
        console.log("⏰ Session expired, logging out");
        logout();
        return false;
      }

      // Show warning when 1 minute or less remains
      if (remainingTime <= WARNING_TIME && remainingTime > 0) {
        const warningSeconds = Math.floor(remainingTime / 1000);
        console.log(`⚠️ Session expiring in ${warningSeconds} seconds`);

        /* // You can show a modal warning here if needed
        if (warningSeconds === 60) { // Show warning only once at 1 minute
          alert(`Your session will expire in 1 minute. Please save your work.`);
        } */
      }
    } else {
      // No activity time found, set it now
      resetTimer();
    }

    return true;
  };

  const checkApiStatus = async () => {
    try {
      const response = await fetch(`${API_URL}/api/laravel-test`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        timeout: 10000,
      });

      if (response.ok) {
        setApiStatus(true);
        return true;
      } else {
        setApiStatus(false);
        return false;
      }
    } catch (error) {
      console.error("🚨 API status check failed:", error);
      setApiStatus(false);
      return false;
    }
  };

  const handleTransactionNavigation = (e) => {
    e.preventDefault();
    resetTimer();
    navigate("/retail-agent/transaction");
  };

  // Function to process URL parameters for OAuth tokens
  const processOAuthToken = () => {
    const queryParams = new URLSearchParams(location.search);
    const tokenFromUrl = queryParams.get("token");
    const firstLogin = queryParams.get("firstLogin") === "true";

    if (tokenFromUrl) {
      console.log("🔑 OAuth token received via URL");
      localStorage.setItem("auth_token", tokenFromUrl);
    }

    // ✅ Handle firstLogin even if no token in URL
    if (firstLogin) {
      console.log("🎉 First login detected from URL");
      localStorage.setItem("is_first_login", "true");
    }

    // Initialize session timer
    resetTimer();

    // ✅ Clear URL parameters without reloading
    if (tokenFromUrl || firstLogin) {
      window.history.replaceState({}, document.title, "/retail-agent/wallet");
    }

    return !!(tokenFromUrl || firstLogin);
  };

  const fetchWalletData = async (token) => {
    try {
      const response = await fetch(`${API_URL}/api/agent/wallet`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const contentType = response.headers.get("content-type");
      const isJson = contentType && contentType.includes("application/json");

      if (!response.ok) {
        const errorData = isJson
          ? await response.json()
          : await response.text();
        const message = isJson
          ? errorData.message || "Failed to fetch wallet data"
          : `Error ${response.status}: ${response.statusText}`;
        throw new Error(message);
      }

      const data = await response.json();
      setTransactions(data.transactions || []);
      setBalance(data.points || 0);

      // Handle first login popup for OAuth users
      const isFirstLogin = localStorage.getItem("is_first_login") === "true";
      if (isFirstLogin) {
        setShowPopup(true);
        localStorage.setItem("is_first_login", "false");
      }

      return true;
    } catch (error) {
      console.error("🚨 Wallet fetch error:", error.message);
      if (
        error.message.includes("401") ||
        error.message.includes("403") ||
        error.message.includes("500")
      ) {
        logout();
        return false;
      }
      throw error;
    }
  };

  useEffect(() => {
    const initWallet = async () => {
      try {
        // FIRST: Check for OAuth token in URL (highest priority)
        const hasOAuthToken = processOAuthToken();

        // SECOND: Check session validity
        const isSessionValid = checkSession();
        if (!isSessionValid) {
          return;
        }

        // THIRD: Check API status
        const isApiOnline = await checkApiStatus();

        if (!isApiOnline) {
          console.error("API is not available, redirecting to login");
          logout();
          return;
        }

        // FOURTH: Get token
        const token = localStorage.getItem("auth_token");
        if (!token) {
          navigate("/work_with_tcuk");
          return;
        }

        // FIFTH: Fetch wallet data
        await fetchWalletData(token);
      } catch (error) {
        console.error("🚨 Wallet initialization error:", error);
      } finally {
        setLoading(false);
      }
    };

    initWallet();

    // Setup activity listeners
    const cleanupActivityListeners = setupActivityListeners();

    // Set up session check interval (every 10 seconds)
    const sessionCheckInterval = setInterval(() => {
      checkSession();
    }, 10000);

    // Set up countdown timer (every second)
    const countdownInterval = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          checkSession(); // Force session check when time reaches 0
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => {
      cleanupActivityListeners();
      clearInterval(sessionCheckInterval);
      clearInterval(countdownInterval);
    };
  }, [navigate, location]);

  // Format time for display
  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds.toString().padStart(2, "0")}`;
  };

  // Show API checking/loading UI
  if (apiStatus === false) {
    return (
      <div className="wallet-loading">
        <LoginHeaderA />
        <div className="wallet-container" style={{ maxWidth: "500px" }}>
          <div className="wallet-content">
            <div className="wallet-left">
              <div className="wallet-left-text">
                <h2 className="highlight">Service Unavailable</h2>
                <p>Please try again later.</p>
                <button
                  onClick={() => navigate("/work_with_tcuk")}
                  className="active-button"
                >
                  Return to Login
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Show loading UI while fetching
  if (loading || apiStatus === null) {
    return (
      <div className="wallet-loading">
        <LoginHeaderA />
        <div className="wallet-container" style={{ maxWidth: "500px" }}>
          <div className="wallet-content">
            <div className="wallet-left">
              <div className="wallet-left-text">
                <h2 className="highlight">TopCoin Wallet</h2>
                <p className="balance-label">Available Balance</p>
                <h1 className="balance-value">Loading...</h1>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="pt-5" style={{ backgroundColor: "#001964" }}>
      <LoginHeaderA />

      {/* Session Timer Display */}
      {/* <div style={{
        position: 'fixed',
        top: '100px',
        right: '20px',
        backgroundColor: timeLeft <= 60 ? '#ff6b6b' : '#4ecdc4',
        color: 'white',
        padding: '8px 12px',
        borderRadius: '20px',
        fontSize: '14px',
        fontWeight: 'bold',
        zIndex: 1000,
        boxShadow: '0 2px 10px rgba(0,0,0,0.3)'
      }}>
        ⏰ Session: {formatTime(timeLeft)}
      </div> */}

      <div className="wallet-container">
        <div className="wallet-content">
          <div className="wallet-left">
            <div className="wallet-left-text">
              <h2 className="highlight">TopCoin Wallet</h2>
              <img
                className="wallet-icon1"
                src={tcunitswallet}
                alt="wallet icon"
              />
              <p className="balance-label">Available Balance</p>
              <h1 className="balance-value">{balance} TopCoin</h1>
              <div className="mb-8 pt-4 text-center">
                <button
                  onClick={handleTransactionNavigation}
                  style={{
                    color: "#9F4AFF",
                    fontWeight: "500",
                    textDecoration: "none",
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    fontSize: "inherit",
                  }}
                >
                  Transaction History &gt;&gt;
                </button>
              </div>
            </div>

            <div className="wallet-left-text wallet-left-text2">
              <h2 className="highlight">Current TopCoin Value</h2>
              <img
                className="wallet-icon1"
                src={walletcashicon}
                alt="wallet icon"
              />
              <h1 className="coin-value">
                Current value = £{(balance * 0.005).toFixed(2)}
              </h1>
            </div>
          </div>

          <div className="wallet-left wallet-left1">
            <div className="wallet-left-text wallet-left-text1">
              <h2 className="highlight">TopCoin Cash Wallet</h2>
              <img
                className="wallet-icon1"
                src={tccashwallet}
                alt="wallet icon"
              />
              <h2 className="highlight cash-wallet1">N/A</h2>
            </div>

            <div className="bank-request">
              <p className="convert-text">Convert your TopCoin into cash</p>
              <img className="bank-icon" src={bankicon} alt="bankicon" />
              <h1 className="coin-value " style={{ color: "#888" }}>
                Request to bank
              </h1>
              <button
                className={
                  balance >= 20000 ? "active-button" : "disabled-button2"
                }
                onClick={handleClick}
              >
                Request
              </button>
              {showMessage && (
                <h3 className="message">
                  This feature will be available once you reach 20,000 TopCoin.
                </h3>
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default WalletA;
